module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.d7e10e0.eot";